import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import config from '../../constants/config';
import { oauthLogin } from '../../actions/auth';

const MicrosoftLogin = (props) => {
    const dispatch = useDispatch();
    const { history } = props;
    const clientId = config && config.oauth && config.oauth.microsoft && config.oauth.microsoft.CLIENT_ID
        ? config.oauth.microsoft.CLIENT_ID : null;
    const redirectUri = config && config.oauth && config.oauth.microsoft && config.oauth.microsoft.REDIRECT_URI
        ? config.oauth.microsoft.REDIRECT_URI : null;
    const scopes = config && config.oauth && config.oauth.microsoft && config.oauth.microsoft.SCOPES
        ? config.oauth.microsoft.SCOPES : null;
    const prompt = config && config.oauth && config.oauth.microsoft && config.oauth.microsoft.PROMPT
        ? config.oauth.microsoft.PROMPT : null;

    const [isSignedIn, setIsSignedIn] = useState(false);
    const [showSignInPopup, setSignInPopUp] = useState(false);
    const [signedUserDetails, setSignedUserDetails] = useState(null);

    const isRequest = useSelector((state) => state.auth.isRequest)

    useEffect(() => {
        if (showSignInPopup) {
            login()
        }
    }, [showSignInPopup])

    useEffect(() => {
        if (signedUserDetails) {
            callOauthLoginApi();
        }
    }, [signedUserDetails])

    const callOauthLoginApi = () => {
        const cb = () => {
            setIsSignedIn(false);
        }
        setIsSignedIn(true);
        dispatch(oauthLogin(signedUserDetails, history, cb));

    }

    const login = async () => {
        const msConfig = {
            auth: {
                clientId,
                redirectUri
            }
        }
        const pca = new window.msal.PublicClientApplication(msConfig);
        const accountDetails = await pca.loginPopup({
            scopes,
            prompt
        })
        if (accountDetails && accountDetails.account && accountDetails.account.username) {
            setSignedUserDetails({ login: accountDetails.account.username, provider: 4 })
        } else {
            setSignedUserDetails(null)
        }
    }

    return (
        <div className="microsoft-login-btn">
            <div id="customBtn" className={`${isRequest && "disabled"}`}>
                <span className={`buttonText`} onClick={() => setSignInPopUp(true)}>
                    <img className="microsoft_logo" src={require(`../../../assets/images/auth_microsoft.png`)} alt="" />{isSignedIn ? "Authenticating..." : "Sign in with Microsoft"}
                </span>
            </div>
        </div >
    )
}

export default MicrosoftLogin;